import React, { useCallback, useEffect, useRef } from 'react';
import $ from 'jquery';
import { p_nbsp } from '../../utils';
import logo from '../../assets/images/logo.png';
import { useLocation } from 'react-router-dom';

function Preloader() {
    const { pathname, search } = useLocation();
    const isFirstRouteRender = useRef(true);
    const hideLoaderTimeoutRef = useRef(null);

    const clearHideTimeout = useCallback(() => {
        if (hideLoaderTimeoutRef.current != null) {
            window.clearTimeout(hideLoaderTimeoutRef.current);
            hideLoaderTimeoutRef.current = null;
        }
    }, []);

    const hidePreloader = useCallback((delay = 0) => {
        clearHideTimeout();
        hideLoaderTimeoutRef.current = window.setTimeout(() => {
            document.body.classList.add('loaded');
            document.body.classList.remove('route-loading');
            hideLoaderTimeoutRef.current = null;
        }, delay);
    }, [clearHideTimeout]);

    const showPreloader = useCallback(() => {
        clearHideTimeout();
        document.body.classList.remove('loaded');
        document.body.classList.add('route-loading');
    }, [clearHideTimeout]);

    useEffect(() => {
        const handleWindowReady = () => {
            // add loaded class to body so that preloader can disappear
            hidePreloader(0);

            // if ($('.comment-form--wrapper').length < 1 && $('.related-posts').length > 0) {
            //     $('.related-posts').css('margin-top', '15rem');
            // }

            if ($('.related-posts').length > 0) {
                $('.default-footer').css('margin-top', 0);
            }

            $('.navigation').on('navigationOpened', () => {
                if ($('.navigation .logo > *').length > 0) {
                    $('.navigation .hamburger').addClass('align');
                }
            });

            $('.blog-single-content-wrapper > p').each((index, element) => {
                let fontSize = parseInt($(element).css('font-size').replace('px', ''));
                let lineHeight = parseInt($(element).css('line-height').replace('px', ''));

                if (isNaN(lineHeight) || isNaN(fontSize) || fontSize === lineHeight) return;

                if (fontSize > lineHeight) {
                    $(element).css('line-height', fontSize + 14 + 'px');
                }
            });
        };

        $(window).on('load.preloader', handleWindowReady);
        $(window).on('pageshow.preloader', handleWindowReady);

        $(window).on('load.preloader', p_nbsp);
        $(window).on('pageshow.preloader', p_nbsp);
        $(window).on('resize.preloader', p_nbsp);

        if (document.readyState === 'complete') {
            handleWindowReady();
        } else {
            // Safety valve for iOS/WebKit cases where load timing is unreliable.
            hidePreloader(2500);
        }

        return () => {
            clearHideTimeout();
            $(window).off('.preloader');
        };
    }, [clearHideTimeout, hidePreloader]);

    useEffect(() => {
        if (isFirstRouteRender.current) {
            isFirstRouteRender.current = false;
            return undefined;
        }

        // Ensure the loader always appears during route transitions
        showPreloader();
        hidePreloader(420);

        return () => {
            clearHideTimeout();
        };
    }, [pathname, search, clearHideTimeout, hidePreloader, showPreloader]);

    return (
        <div className="preloader">
            <div className="preloader__overlay" aria-hidden="true"></div>
            <div className="preloader__logo-stage" aria-hidden="true">
                <img className="preloader__logo-image preloader__logo-image-shift" src={logo} alt="" />
                <img className="preloader__logo-image" src={logo} alt="" />
            </div>
            <span className="visually-hidden">Loading Studio website</span>
        </div>
    );
}

export default Preloader;
